export default __webpack_public_path__ + "static/1-f5e01530d3f5a814a3c823e12d5de9b0.png";